import React from 'react';

import { Nand } from './components/Nand.jsx'
import { Not } from './components/Not.jsx'
import { And } from './components/And.jsx'
import { Or } from './components/Or.jsx'
import { Nor } from './components/Nor.jsx'
import { Xor } from './components/Xor.jsx'
import { Mux } from './components/Mux.jsx'
import { Demux } from './components/Demux.jsx'

function App() {
  return (
    <div className="App">
      <h1>
        Boolean Logic Gates
      </h1>
      <Nand />
      <Not />
      <And />
      <Or />
      <Nor />
      <Xor />
      <Mux />
      <Demux />
    </div>
  );
}

export default App;
